
const store = {
    state: {
        langurage:1
    },
    mutations: {
        CHANGE_LAN(state, str) {
            state.langurage = str;
        }
    },
    getters: {
        GET_ROUTER_LAN(state) {
            return state.langurage
        }
    }
}
export default store


// WEBPACK FOOTER //
// ./src/store/store.js